"use strict";
window.theme = window.theme || {}
theme.CartDrawer = function() {
    function CartDrawer() {
        this.selector = {
            cartbubble: document.getElementById('cart-icon-bubble'),
            cartdrawer: document.getElementById('cart-drawer'),
            cartdraweroverlay: document.getElementById('cart-drawer-overlay'),
            cartdrawerclose: document.getElementById('cart-drawer-close'),
            formcartdrawer: document.getElementById('form-cart-drawer'),
            cartdraweritemcount: document.getElementById('cart-drawer-item-count'),
            cartcountbubble: document.getElementById('cart-count-bubble'),
            dataproductform: document.getElementById('data-product-form'),
            cartcouponcodecollapsable: document.querySelector('.cart-footer-details .coupon-code'),
            cartordernotescollapsable: document.querySelector('.cart-footer-details .order-notes'),
            cartdrawerordernotes: document.getElementById('cart-drawer-order-notes'),
            cartdrawerupsell: document.getElementById('cart-drawer-upsell'),
            cartdrawercheckout: document.querySelector('#cart-drawer > .cart-footer > #checkout'),
            addtocart: document.querySelector('[data-add-to-cart]')
        }
        this.state = {
            quantity: null,
            discountcode: null,
            discountKeySubmit: false
        }
        this.load();
    }
    CartDrawer.prototype.load = async function() {
        var _ = this;
        if(_.selector.cartbubble) {
            _.selector.cartbubble.addEventListener('click', event => {
                event.preventDefault();
                _.selector.cartdrawer.classList.add('active');
                _.selector.cartdraweroverlay.classList.add('active');
                theme.PromotionalProgressbar.recalculate();
                document.body.classList.add("scroll-lock");
            })
        }
        if(_.selector.cartdrawerclose) {
            _.selector.cartdrawerclose.addEventListener('click', () => {
                _.selector.cartdrawer.classList.remove('active');
                _.selector.cartdraweroverlay.classList.remove('active');
                document.body.classList.remove("scroll-lock");
            })
        }
        if(_.selector.formcartdrawer) {
            _.selector.formcartdrawer.addEventListener('submit', event => {
                event.preventDefault();    
                if(event.submitter.classList.contains('minus')) {
                    const control_quantity = event.submitter.closest('.quantity-control')?.querySelector('.quantity');
                    if(control_quantity && parseInt(control_quantity.value) > 1) {
                        control_quantity.value = parseInt(control_quantity.value) - 1;
                        _.updatequantity(event.submitter);
                    }                   
                }        
                if(event.submitter.classList.contains('plus')) {
                    const control_quantity = event.submitter.closest('.quantity-control')?.querySelector('.quantity');
                    if(control_quantity && parseInt(control_quantity.value) > 0) {
                        control_quantity.value = parseInt(control_quantity.value) + 1;
                        _.updatequantity(event.submitter);
                    }                   
                }           
                if(event.submitter.classList.contains('remove')) {
                    const control_quantity = event.submitter.closest('.quantity-control')?.querySelector('.quantity');
                    if(control_quantity) {
                        control_quantity.value = 0;
                        _.updatequantity(event.submitter);
                    }                   
                } 
                if(event.submitter.classList.contains('remove-qty-is-one') && !_.state.discountKeySubmit) {
                    const control_quantity = event.submitter.closest('.quantity-control')?.querySelector('.quantity');
                    if(control_quantity) {
                        control_quantity.value = 0;
                        _.updatequantity(event.submitter);
                    }       
                } 
                if(_.state.discountKeySubmit) {
                    event.target.closest("form.cart-items").querySelector(".discount-code-container > button").classList.add("active", "js-loading");
                    _.checkoutapplydiscountcode(event.target.closest("form.cart-items").querySelector('#cart-drawer-coupon').value, event.target.closest("form.cart-items").querySelector(".discount-code-container > button"));
                    _.state.discountKeySubmit = false;
                }
                if(event.submitter.classList.contains('cart-drawer-checkout')) {
                    if(!event.submitter.disabled) {
                        event.submitter.classList.add('js-loading');
                        window.location.href = '/checkout';
                    }                   
                }       
                if(event.submitter.classList.contains('order-notes-submit')) {
                    event.submitter.classList.add("active");
                    _.updatenotes(event.submitter);

                }
            })
            _.selector.formcartdrawer.addEventListener("keyup", event => {
                event.preventDefault();
                if(event.target.closest("input.quantity") && !isNaN(event.target.closest("input.quantity").value)) {
                    _.updatequantity(event.target);
                }
                if(event.target.closest("textarea#cart-drawer-order-notes")) {
                    if(event.target.closest(".order-notes").querySelector(".order-notes-submit").type === "button") {
                        event.target.closest(".order-notes").querySelector(".order-notes-submit").type = "submit";
                    }                   
                } 
                if(event.target.closest('#cart-drawer-coupon')) {
                    _.state.discountKeySubmit = true;
                }  
            })
            _.selector.formcartdrawer.addEventListener("click", async event => {
                if(event.target.closest(".discount-code-container") && event.target.closest(".discount-code-container").querySelector('#cart-drawer-coupon').value !== "") {
                    event.target.closest("button") && event.target.closest("button").classList.add("active", "js-loading");
                    _.checkoutapplydiscountcode(event.target.closest(".discount-code-container").querySelector('#cart-drawer-coupon').value, event.target.closest("button"));
                    _.state.discountKeySubmit = false;
                }    
                if(event.target.closest(".remove-discount")) {
                    event.target.closest("button") && event.target.closest("button").classList.add("active", "js-loading");
                    _.checkoutapplydiscountcode("remove-discount-code", event.target.closest("button"));
                }  
                if(event.target.closest(".order-notes-submit")) {
                    event.target.closest(".order-notes").querySelector("textarea").classList.remove("disabled");
                    event.target.closest(".order-notes-submit").textContent = `UPDATE NOTE`;                    
                    event.target.closest(".order-notes").querySelector("textarea").focus();
                }
                if(event.target.closest(".freegift-quick-view-modal-btn")) {
                    event.preventDefault();
                    await theme.QuickView.rendercontent(event.target.closest('.freegift-quick-view-modal-btn').dataset.productUrl); 
                }    
            })
            _.selector.formcartdrawer.addEventListener("change", event => {
                event.preventDefault();
                if(event.target.closest('select.variant-options') && event.target.closest('select.variant-options').selectedIndex > 0) {
                    event.target.closest('.variant-options-container').querySelector('button').disabled = false;      
                } 
            })
            _.selector.formcartdrawer.addEventListener("mousedown", async event => {
                if(event.target.closest(".freegift-quick-view-modal-btn")) {
                    event.preventDefault();
                }    
            })
            _.selector.formcartdrawer.addEventListener("touchstart", async event => {
                if(event.target.closest(".freegift-quick-view-modal-btn")) {
                    event.preventDefault();
                }    
            })
        }
        if(_.selector.addtocart) {
            var targetNode = _.selector.addtocart;
            var config = { attributes: true, attributeFilter: ['class'] };
            var callback = function(mutationsList, observer) {
            for(var mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if(mutation.target.className.includes('added')) {
                        _.addtocart();
                    }
                }
            }
            };
            var observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        }
        if(_.selector.cartdrawer) {
            _.selector.cartdrawer.addEventListener('click', async event => {  
                if(event.target.closest('.coupon-code-heading')) {
                    var lkcCoupon = event.target.closest('.coupon-code');
                    lkcCoupon.classList.toggle('active');
                    // T5.57 — On open, scroll the apply field into view so it isn't left
                    // below the fold behind the sticky footer (verified: scroll area ~460px
                    // vs ~929px content). scroll-margin-bottom (CSS) keeps a gap above it.
                    if(lkcCoupon.classList.contains('active')) {
                        var lkcCt = lkcCoupon.querySelector('.discount-code-container');
                        if(lkcCt) requestAnimationFrame(function(){ lkcCt.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); });
                    }
                }
                if(event.target.closest('.order-notes-heading')) {
                    var lkcNotes = event.target.closest('.order-notes');
                    lkcNotes.classList.toggle('active');
                    if(lkcNotes.classList.contains('active')) {
                        var lkcNb = lkcNotes.querySelector('.order-notes-submit');
                        if(lkcNb) requestAnimationFrame(function(){ lkcNb.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); });
                    }
                }
                if(event.target.closest('.freegift-add-to-cart')) {
                    const selectedOption = event.target.closest('.variant-options-container').querySelector('select');
                    if(selectedOption) {
                        event.target.closest('.freegift-add-to-cart').disabled = true;
                        await _.addfreegift(selectedOption.options[selectedOption.selectedIndex].value);
                        event.target.closest('.freegift-add-to-cart').disabled = false;
                    }              
                }    
            })
        }
        if(_.selector.cartdraweroverlay) {
            _.selector.cartdraweroverlay.addEventListener('click', event => {
                event.preventDefault();
                _.selector.cartdrawer.classList.remove('active');
                _.selector.cartdraweroverlay.classList.remove('active');
                document.body.classList.remove("scroll-lock");
            })
        }
        if(_.selector.cartbubble) {
            if(window.location.pathname === '/cart') {
            
                await theme.PromotionalProgressbar.recalculate();
                document.body.classList.add("scroll-lock");
                _.selector.cartdrawer.classList.add('active');
                _.selector.cartdraweroverlay.classList.add('active');
            }
        }
    }
    CartDrawer.prototype.updatequantity = async function(submitter) {
        var _ = this;
        _.selector.cartdrawercheckout.disabled = true;
        _.selector.cartdrawercheckout.classList.add('js-loading');
        const control_quantity = submitter.closest('.quantity-control')?.querySelector('.quantity');
        var lkcCartData = null; /* T5.76 — stash the cart/change.js cart JSON so recalculate can reuse it instead of re-fetching cart.js */
        const formData = {
            'id': control_quantity.dataset.itemKey,
            'quantity': parseInt(control_quantity.value),
            'sections': 'cart-drawer'
        }          
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
        })
        .then(response => {
              return response.json();
        })
        .then(data => {
            lkcCartData = data; /* T5.76 — change.js returns the full updated cart (total_price/original_total_price/items) */
            _.selector.cartdraweritemcount.querySelector(".count-label").textContent = data.item_count;
            _.selector.cartcountbubble.textContent = data.item_count;
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(data.sections["cart-drawer"], 'text/html');               
                const specificContainer = htmlDoc.getElementById('form-cart-drawer'); 
                if (specificContainer) {
                    _.selector.formcartdrawer.innerHTML = specificContainer.innerHTML;
                } else {
                    console.error('Specific container not found');
                }  
        })
        .catch(error => {
            const control_quantity = submitter.closest('.quantity-control')?.querySelector('.quantity');
            control_quantity.value = parseInt(control_quantity.value) - 1;
            console.error(error);
        })
        .finally(() => {
            _.selector.cartdrawercheckout.disabled = (parseInt((document.querySelector('#cart-drawer-item-count .count-label') || {}).textContent) || 0) === 0; /* T5.55 idx17 — keep checkout disabled when cart is empty */
            _.selector.cartdrawercheckout.classList.remove('js-loading');
            if(submitter.classList.contains('free-gift')) {
                theme.PromotionalProgressbar.state.deletedFreeGift.push(control_quantity.dataset.itemId);
            }        
            theme.PromotionalProgressbar.recalculate(lkcCartData); /* T5.76 — reuse change.js cart; recalculate skips its own cart.js fetch (falls back to fetch on error when null) */
            theme.CartDrawerUpsell.load();
            theme.QuickView.load();
        });
    }
    CartDrawer.prototype.updatenotes = async function(submitter) {
        var _ = this;
        _.selector.cartdrawercheckout.disabled = true;
        const cartdrawerordernotes = document.getElementById('cart-drawer-order-notes');
        const formData = {
            'note': cartdrawerordernotes.value,
            'sections': 'cart-drawer'
        }          
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
        })
        .then(response => {
              return response.json();
        })
        .then(data => {
            _.selector.cartdraweritemcount.querySelector(".count-label").textContent = data.item_count;
            _.selector.cartcountbubble.textContent = data.item_count;
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(data.sections["cart-drawer"], 'text/html');
                const specificContainer = htmlDoc.getElementById('form-cart-drawer'); 
                if (specificContainer) {
                    _.selector.formcartdrawer.innerHTML = specificContainer.innerHTML;
                } else {
                    console.error('Specific container not found');
                }    
        })
        .catch(error => {
         console.error(error);
        })
        .finally(() => {
            submitter.classList.remove("active");
            _.selector.cartdrawercheckout.disabled = (parseInt((document.querySelector('#cart-drawer-item-count .count-label') || {}).textContent) || 0) === 0; /* T5.55 idx17 — keep checkout disabled when cart is empty */
        });
    }
    CartDrawer.prototype.addtocart = async function(form) {
        var _ = this;        
        _.selector.cartdrawercheckout.disabled = true;
        await fetch(window.Shopify.routes.root + '?sections=cart-drawer')
        .then(response => response.json())
        .then(async data => {
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(data["cart-drawer"], 'text/html');
                const specificContainer = htmlDoc.getElementById('form-cart-drawer');   
                const cartCount = htmlDoc.getElementById('cart-drawer-item-count');
                if(cartCount) {
                    _.selector.cartdraweritemcount.querySelector(".count-label").textContent = cartCount.textContent;
                    _.selector.cartcountbubble.textContent = cartCount.textContent;
                }
                if (specificContainer) {
                    _.selector.formcartdrawer.innerHTML = specificContainer.innerHTML;
                } else {
                    console.error('Specific container not found');
                } 
        })
        .catch(error => {
            console.error(error);
        })
        .finally(() => {
            _.selector.cartdrawer.classList.add('active');
            _.selector.cartdraweroverlay.classList.add('active');
           theme.PromotionalProgressbar.recalculate();
            _.selector.cartdrawercheckout.disabled = (parseInt((document.querySelector('#cart-drawer-item-count .count-label') || {}).textContent) || 0) === 0; /* T5.55 idx17 — keep checkout disabled when cart is empty */
            theme.CartDrawerUpsell.load();
            theme.QuickView.load();
        });
    }
    CartDrawer.prototype.checkoutapplydiscountcode = async function(code,target) {
        var _ = this;
        _.state.discountcode = code;
    
        // Handle discount removal using cart/update.js
        if(code === "remove-discount-code") {
            const formData = {
                'discount': '',
                'sections': 'cart-drawer'
            };
            await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => response.json())
            .then(data => {
                if(data && !data.errors) {
                    // Update cart item count
                    if(data.item_count !== undefined) {
                        _.selector.cartdraweritemcount.querySelector(".count-label").textContent = data.item_count;
                        _.selector.cartcountbubble.textContent = data.item_count;
                    }
                    // Update cart drawer HTML if sections are provided
                    if(data.sections && data.sections["cart-drawer"]) {
                        const parser = new DOMParser();
                        const htmlDoc = parser.parseFromString(data.sections["cart-drawer"], 'text/html');
                        const specificContainer = htmlDoc.getElementById('form-cart-drawer');
                        if (specificContainer) {
                            _.selector.formcartdrawer.innerHTML = specificContainer.innerHTML;
                        }
                    }
                    target.classList.add("active");
                    _.repaintcartdrawer();
                } else {
                    console.error('Failed to remove discount code:', data.errors);
                    target.classList.remove("active", "js-loading");
                }
            })
            .catch(error => {
                console.error('Error removing discount:', error);
                target.classList.remove("active", "js-loading");
            });
        } else {
            // Apply discount code
            await fetch(`/discount/${_.state.discountcode}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                if(response.ok) {
                    target.classList.add("active");
                    _.repaintcartdrawer();
                } else {
                    console.error('Failed to apply discount code');
                    target.classList.remove("active", "js-loading");
                }
            })
            .catch(error => {
                console.error('Error applying discount:', error);
                target.classList.remove("active", "js-loading");
            });
        }
    }
    CartDrawer.prototype.repaintcartdrawer = async function() {
        var _ = this;     
        await fetch(window.Shopify.routes.root + '?sections=cart-drawer')
        .then(response => {
              return response.json();
        })
        .then(async data => {
            const parser = new DOMParser();
            const htmlDoc = parser.parseFromString(data["cart-drawer"], 'text/html');
            const specificContainer = htmlDoc.getElementById('form-cart-drawer');             
            if (specificContainer) {
                _.selector.formcartdrawer.innerHTML = specificContainer.innerHTML;
                const discountCodeApplied = specificContainer.querySelector('#cart-discounts-added-list');
                if(discountCodeApplied && _.state.discountcode !== "remove-discount-code") {
                    const couponcodecontainer = document.getElementById("cart-drawer-coupon-code");
                    couponcodecontainer.classList.add("active");
                    const successnotification = document.getElementById("cart-drawer-success-notification");
                    successnotification.classList.add("active");                   
                    setTimeout(() => {
                        successnotification.classList.remove("active");
                    },5000);
                } else if(_.state.discountcode !== "remove-discount-code") {
                    const couponcodecontainer = document.getElementById("cart-drawer-coupon-code");
                    couponcodecontainer.classList.add("active");
                    const errornotification = document.getElementById("cart-drawer-error-notification");
                    errornotification.classList.add("active");
                    setTimeout(() => {
                        errornotification.classList.remove("active");
                    },5000);
                } else if(_.state.discountcode === "remove-discount-code") {
                    const couponcodecontainer = document.getElementById("cart-drawer-coupon-code");
                    couponcodecontainer.classList.add("active");
                    const removenotification = document.getElementById("cart-drawer-remove-notification");
                    removenotification.classList.add("active");
                    setTimeout(() => {
                        removenotification.classList.remove("active");
                    },5000);
                }
                _.state.discountKeySubmit = false;
            } else {
                console.error('Specific container not found');
                _.state.discountKeySubmit = false;
            } 
        })
        .catch(error => {
            console.error(error);
        })
        .finally(() => {
            // Recalculate promotional progress bar to reflect new discounted cart total
            theme.PromotionalProgressbar.recalculate();
            // Re-initialize other components that depend on cart drawer HTML
            theme.CartDrawerUpsell.load();
            theme.QuickView.load();
        });
    }
    CartDrawer.prototype.addfreegift = async function(id) {
        var _ = this;
        _.selector.cartdrawercheckout.disabled = true;
        _.selector.cartdrawercheckout.classList.add('js-loading');
        const formData = {
            'items': [{
                'id': id,
                'quantity': 1
            }],
            'sections': 'cart-drawer'
        }     
        /* T5.36i — Guard against 422/5xx; parse-fail returns null. */
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.ok ? response.json() : null)
        .then(async data => {
            if (!data) return;
            _.selector.cartdraweritemcount.querySelector(".count-label").textContent = data.item_count;
            _.selector.cartcountbubble.textContent = data.item_count;
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(data.sections["cart-drawer"], 'text/html');
                const specificContainer = htmlDoc.getElementById('form-cart-drawer');
                const cartCount = htmlDoc.getElementById('cart-drawer-item-count');
                if(cartCount) {
                    _.selector.cartdraweritemcount.querySelector(".count-label").textContent = cartCount.textContent;
                    _.selector.cartcountbubble.textContent = cartCount.textContent;
                }
                if (specificContainer) {
                    _.selector.formcartdrawer.innerHTML = specificContainer.innerHTML;
                } else {
                    console.error('Specific container not found');
                }
        })
        .catch(error => {
            console.error(error);
        })
        .finally(() => {
            _.selector.cartdrawer.classList.add('active');
            _.selector.cartdraweroverlay.classList.add('active');           
            _.selector.cartdrawercheckout.disabled = (parseInt((document.querySelector('#cart-drawer-item-count .count-label') || {}).textContent) || 0) === 0; /* T5.55 idx17 — keep checkout disabled when cart is empty */
            _.selector.cartdrawercheckout.classList.remove('js-loading');
            theme.PromotionalProgressbar.recalculate();
            theme.CartDrawerUpsell.load();
            theme.QuickView.load();     
        });
    }
    theme.CartDrawer = new CartDrawer;
}
theme.CartDrawer();